
import { useState } from 'react';
import { InviteMemberFormData, MemberPermission, permissionOptions } from '../../types/memberTypes';

// Function to create a new form data object with default values
export const getInitialMemberFormData = (): InviteMemberFormData => {
  // Deep clone permissions array to avoid reference issues
  const clonedPermissions = JSON.parse(JSON.stringify(permissionOptions));
  
  // Set viewOnly to true by default
  const initialPermissions = clonedPermissions.map((p: MemberPermission) => ({
    ...p,
    checked: p.id === 'viewOnly' ? true : false
  }));
  
  return {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'Manager',
    permissions: initialPermissions,
    setFormField: () => {}, // This will be set in the hook
  };
};

export const useMemberForms = () => {
  // Deep clone permissions array to avoid reference issues
  const defaultPermissions: MemberPermission[] = JSON.parse(JSON.stringify(permissionOptions));
  
  // Set viewOnly to true by default
  const initialPermissions = defaultPermissions.map(p => ({
    ...p,
    checked: p.id === 'viewOnly' ? true : false
  }));
  
  // Form state for inviting a new member
  const [inviteMemberForm, setInviteMemberForm] = useState<InviteMemberFormData>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'Manager',
    permissions: initialPermissions,
    setFormField: (field, value) => {
      console.log(`Setting form field "${field}" to:`, value);
      setInviteMemberForm(prev => ({
        ...prev,
        [field]: value
      }));
    }
  });
  
  // Reset the form to its default state
  const resetInviteMemberForm = () => {
    console.log('Resetting invite member form');
    
    // Re-clone permissions to ensure we always get a fresh copy
    const freshPermissions = JSON.parse(JSON.stringify(permissionOptions));
    const resetPermissions = freshPermissions.map((p: MemberPermission) => ({
      ...p,
      checked: p.id === 'viewOnly' ? true : false
    }));
    
    setInviteMemberForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      role: 'Manager',
      permissions: resetPermissions,
      setFormField: (field, value) => {
        console.log(`Setting form field "${field}" to:`, value);
        setInviteMemberForm(prev => ({
          ...prev,
          [field]: value
        }));
      }
    });
  };

  return {
    inviteMemberForm,
    setInviteMemberForm,
    resetInviteMemberForm
  };
};
